"use client";

import Link from "next/link";
import { useParams } from "next/navigation";
import { AdminBreadcrumb, AdminTitle } from "@/shared";
import { AdminArticlePath, AdminArticleTitle } from "@/entities";

export function AdminArticleListPage() {
  const params = useParams<{ slug: string }>();
  const slug = params?.slug || "";

  return (
    <>
      <div className="d-flex align-items-center">
        <div>
          <AdminBreadcrumb items={AdminArticlePath} />
          <AdminTitle title={AdminArticleTitle} />
        </div>
        <div className="ms-auto">
          <Link
            href={`/admin/${slug}/new`}
            className="btn btn-white"
            role="button"
          >
            <i className="fa fa-pen"></i>
            <span> 등록</span>
          </Link>
        </div>
      </div>
    </>
  );
}
